import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { useRefresh } from '../context/RefreshContext';

export function useDispatchBoard(startDate, endDate, buId) {
  const [data, setData] = useState({ summary: {}, capacity: [], unassignedJobs: [], jobs: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { refreshCount } = useRefresh();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (buId) params.bu_id = buId;
    apiClient.get('/dispatch/board', { params })
      .then(res => { if (!cancelled) setData(res.data); })
      .catch(err => { if (!cancelled) setError(err.response?.data?.error || 'Failed to load dispatch board'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [refreshCount, startDate, endDate, buId]);

  return { ...data, loading, error };
}
